import React, { useState } from 'react';
import AppTabs from '../components/AppTabs';
import CardsList from './CardsList';
import DocumentsList from './DocumentsList';
import PasswordsList from './PasswordsList';

const MainScreen = () => {
  const [activeTab, setActiveTab] = useState('passwords');

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-6">
      <div className="w-full mx-auto">
        <div className="flex items-center justify-between gap-2 mb-3">
          <h1 className="flex items-center gap-2 text-2xl font-bold text-gray-900">
            <i className="fa-solid fa-key text-orange-500" />
            Passswords
          </h1>
          <span className="text-xs text-gray-500 shrink-0">v1.0</span>
        </div>

        <AppTabs activeTab={activeTab} onTabChange={setActiveTab} />

        {activeTab === 'passwords' && <PasswordsList />}
        {activeTab === 'cards' && <CardsList />}
        {activeTab === 'documents' && <DocumentsList />}
      </div>
    </div>
  );
};

export default MainScreen;
